import { render } from "./TripInspirations.vue?vue&type=template&id=9d464fc8"
import script from "./TripInspirations.vue?vue&type=script&lang=js"
export * from "./TripInspirations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__